import { createFileRoute } from '@tanstack/react-router';
import { UpgradesIndex } from '@/pages/upgrades/UpgradesIndex';

export const Route = createFileRoute('/upgrades')({
	component: UpgradesIndex,
});
